export enum DefaultOnOff {
    DEFAULT = "Default",
    On = "Turn On",
    Off = "Turn Off",
}
